import React from 'react';
import { Input, Col, Row, Form } from 'antd';

const { Item } = Form;

const PostalAddress = () => {
  return (
    <Row span={24}>
      <Col xs={8} md={4}>
        <h4>Postal Address</h4>
      </Col>
      <Col xs={24} md={20}>
        <Item name="postalAddress">
          <Input.TextArea
            size="large"
            name="postalAddress"
            autoSize={{ minRows: 3 }}
            maxLength={150}
            style={{ borderRadius: 8 }}
            placeholder="Your Postal Address"
          />
        </Item>
      </Col>
    </Row>
  );
};

export default PostalAddress;
